<template>
    <!--Breadcrumbs-->
    <div class="tm-grey-text tm-breadcrumbs">
        <router-link to="/partner/dashboard" class="hover:underline">Home</router-link>
        <span class="mx-2">›</span>
        <router-link to="/partner/customers" class="hover:underline">Customers</router-link>
        <span class="mx-2 tm-accent">›
            {{ customerName }}</span>
        <span v-if="botName != ''" class="mx-2">›</span>
        <router-link v-if="botName != ''" to="/partner/customer?activeTab=bots" class="hover:underline"
            @click="clearBotDetails">AI
            Agents</router-link>
        <!-- <a v-if="botName != ''" href="#" class="hover:underline" @click.prevent="clearBotDetails">
            AI Agents
        </a> -->
        <span v-if="botName != ''" class="mx-2 tm-accent">›
            {{ botName }}</span>
        <span v-if="campaignName != ''" class="mx-2">›</span>
        <router-link v-if="campaignName != ''" to="/partner/customer?activeTab=outboundCampaign"
            class="hover:underline">Outbound Campaigns</router-link>
    </div>

    <!--Customer and Bot details-->
    <div class="tm-details" v-if="customerName != '' && botName == ''">
        <h2>{{ customerName }}</h2>
        <hr class="h2" />
        <span v-if="customerName != ''"><b>Customer Name:</b> {{ customerName }}</span><br>
        <span v-if="customerCountry != ''"><b>Country:</b> {{ customerCountry }}</span><br>
        <span v-if="customerEmail != ''"><b>Contact Email:</b> {{ customerEmail }}</span><br>
        <span v-if="customerPhone != ''"><b>Contact Phone:</b> {{ customerPhone }}</span>
    </div>
    <div class="tm-details" v-if="botName != ''">
        <h2><font-awesome-icon icon="fa-microphone-lines" class="tm-accent bot-icon" /> {{ botName }}</h2>
        <br>
        <span v-if="botName != ''"><b>AI Agent Name:</b> {{ botName }}</span><br>
        <span v-if="botType != ''"><b>AI Agent Type:</b> {{ botType }}</span><br>
        <span v-if="botDID != ''"><b>AI Agent DID:</b> {{ botDID }}</span>
    </div>

</template>

<script>
export default {
    data() {
        return {
            customerGUID: '',
            customerName: '',
            customerCountry: '',
            customerEmail: '',
            customerPhone: '',
            botName: '',
            botID: '',
            botType: '',
            botDID: '',
            campaignName: '',
        };
    },
    mounted() {
        this.customerGUID = localStorage.getItem('customerGUID') || '';
        this.customerName = localStorage.getItem('customerName') || '';
        this.customerCountry = localStorage.getItem('customerCountry') || '';
        this.customerEmail = localStorage.getItem('customerEmail') || '';
        this.customerPhone = localStorage.getItem('customerPhone') || '';

        this.botName = localStorage.getItem('botName') || '';
        this.botID = localStorage.getItem('botID') || '';
        this.botType = localStorage.getItem('botType') || '';
        this.botDID = localStorage.getItem('botDID') || '';

        this.campaignName = localStorage.getItem('campaignName') || '';
    }
};
</script>

<style scoped>
/* tm stands for Trimate */
.tm-grey-text>span,
.tm-grey-text>a {
    color: #788e90
}

.tm-accent {
    color: #e45f2b !important
}

.tm-breadcrumbs {
    text-align: left;
}

.tm-breadcrumbs>a,
.tm-breadcrumbs>span {
    font-size: 18px !important;
    font-family: Montserrat, sans-serif;
    text-decoration: none;
}

.tm-details {
    color: black;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 30px;
    text-align: left;
}

.bot-icon {
    font-size: smaller;
}
</style>
